import { z } from 'zod';

export const role = z.enum(['broker', 'admin']);
export type Role = z.infer<typeof role>;

export const brokerStatus = z.enum(['active', 'suspended']);
export type BrokerStatus = z.infer<typeof brokerStatus>;

export const propertyStatus = z.enum(['draft', 'published', 'archived']);
export type PropertyStatus = z.infer<typeof propertyStatus>;

/** Fase do imóvel exibida como selo no card e na página ("Pronto pra morar" / "Lançamento"). */
export const propertyStage = z.enum(['ready', 'launch']);
export type PropertyStage = z.infer<typeof propertyStage>;

/**
 * Tipo de cadastro. `listing` = imóvel avulso à venda (preço único,
 * características próprias); `development` = empreendimento de construtora
 * (faixa de preço, tipologias). Ausente = empreendimento (imóveis antigos).
 */
export const propertyKind = z.enum(['listing', 'development']);
export type PropertyKind = z.infer<typeof propertyKind>;

/** Categoria do imóvel, usada no card e no filtro da página pública. */
export const propertyType = z.enum(['apartment', 'house', 'land', 'commercial']);
export type PropertyType = z.infer<typeof propertyType>;

export const qualificationStatus = z.enum([
  'not_qualified',
  'partially_qualified',
  'fully_qualified',
]);
export type QualificationStatus = z.infer<typeof qualificationStatus>;

export const funnelStage = z.enum([
  'submitted',
  'contacted',
  'visited',
  'proposal',
  'closed_won',
  'closed_lost',
]);
export type FunnelStage = z.infer<typeof funnelStage>;

export const closedLostReason = z.enum([
  'no_response',
  'no_credit',
  'not_interested',
  'chose_competitor',
  'wrong_timing',
  'other',
]);
export type ClosedLostReason = z.infer<typeof closedLostReason>;

export const saleStatus = z.enum(['pending', 'confirmed', 'cancelled']);
export type SaleStatus = z.infer<typeof saleStatus>;

export const incomeSource = z.enum([
  'clt',
  'self_employed',
  'business_owner',
  'retired',
  'informal',
  'other',
]);
export type IncomeSource = z.infer<typeof incomeSource>;

export const maritalStatus = z.enum([
  'single',
  'married',
  'divorced',
  'widowed',
  'stable_union',
]);
export type MaritalStatus = z.infer<typeof maritalStatus>;

export const creditStatus = z.enum(['clean', 'restricted', 'unknown']);
export type CreditStatus = z.infer<typeof creditStatus>;

export const timeline = z.enum([
  'within_1_month',
  '1_to_3_months',
  '3_to_6_months',
  '6_plus_months',
]);
export type Timeline = z.infer<typeof timeline>;

export const metaEventName = z.enum(['Lead', 'QualifiedLead', 'Contact', 'Purchase']);
export type MetaEventName = z.infer<typeof metaEventName>;

export const metaActionSource = z.enum(['website', 'system_generated']);
export type MetaActionSource = z.infer<typeof metaActionSource>;
